import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "danger",
  "use": "danger-usage",
  "viewBox": "0 0 20 17.44",
  "content": "<symbol viewBox=\"0 0 20 17.44\" id=\"danger\"><title>danger</title><path id=\"danger__复合路径_\" data-name=\"&lt;复合路径&gt;\" d=\"M19.94,18,10.39,1.5a.45.45,0,0,0-.77,0L.06,18a.45.45,0,0,0,.39.67h19.1A.45.45,0,0,0,19.94,18Zm-9.17-2.73a.73.73,0,0,1-.73.73H10a.73.73,0,0,1-.73-.73V7.15A.73.73,0,0,1,10,6.42H10a.73.73,0,0,1,.73.73Z\" transform=\"translate(0 -1.28)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/danger.svg
// module id = vyad
// module chunks = 264